var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraCardIcon8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.38514 11.0227C6.01102 10.8322 5.59455 10.7333 5.17102 10.7333C1.86747 10.9663 1.86747 15.7734 5.17102 16.0063H12.9993C13.9522 16.0134 14.8699 15.6604 15.5687 15.0181C17.8911 12.9922 16.6487 8.91921 13.5922 8.53097C12.491 1.91683 2.94042 4.42978 5.20631 10.7333",
    fill: "url(#paint0_linear_1389_9546)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bi_1389_9546)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.75,
    y: 13.12,
    width: 15.7767,
    height: 4.58957,
    rx: 1.43424,
    fill: "url(#paint1_linear_1389_9546)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.7894,
    y: 13.1594,
    width: 15.6979,
    height: 4.51078,
    rx: 1.39484,
    stroke: "white",
    strokeWidth: 0.0787965
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.06836 14.9919L6.77435 15.9769",
    stroke: "white",
    strokeWidth: 0.461516,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.06836 15.9769L6.77435 14.992",
    stroke: "white",
    strokeWidth: 0.461516,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.92188 14.4994L5.92187 16.4693",
    stroke: "white",
    strokeWidth: 0.461516,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74414 14.9918L10.4501 15.9768",
    stroke: "white",
    strokeWidth: 0.461516,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74414 15.9768L10.4501 14.9919",
    stroke: "white",
    strokeWidth: 0.461516,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59766 14.4994L9.59766 16.4693",
    stroke: "white",
    strokeWidth: 0.461516,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4199 14.9919L14.1259 15.9769",
    stroke: "white",
    strokeWidth: 0.461516,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4199 15.9769L14.1259 14.992",
    stroke: "white",
    strokeWidth: 0.461516,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2734 14.4994L13.2734 16.4693",
    stroke: "white",
    strokeWidth: 0.461516,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bi_1389_9546",
    x: 0.962035,
    y: 12.332,
    width: 17.3533,
    height: 6.16553,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.393983
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1389_9546"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1389_9546",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.787965
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.393983
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1389_9546"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1389_9546",
    x1: 9.11463,
    y1: 4.63049,
    x2: 14.3946,
    y2: 18.7466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#388DF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1389_9546",
    x1: 2.67471,
    y1: 13.4759,
    x2: 9.63833,
    y2: 17.7096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A8BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C183FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraCardIcon8);
export default __webpack_public_path__ + "static/media/camera_card_icon8.6cd4f65a432700c691625d9f95bd5f08.svg";
export { ForwardRef as ReactComponent };